import {
  AbandonedCartFlowController,
  AbandonedCartFlowCookieStateStorage,
  AbandonedCartFlowEventBus,
} from "@product/rosetta-sdk";
import type { ReactNode } from "react";
import { createContext, useContext, useEffect, useState } from "react";

import { config } from "shared/data";

import { useRosettaConfig } from "./hooks/rosetta-config";

type ContextValue = {
  abandonedCartFlow?: {
    controller: AbandonedCartFlowController;
    eventBus: AbandonedCartFlowEventBus;
  };
};

const RosettaContext = createContext<ContextValue>({});

export type Props = {
  children?: ReactNode;
};

export const RosettaContextProvider: React.FunctionComponent<Props> = ({ children }) => {
  const [instances, setInstances] = useState<ContextValue>({});

  const { rosettaConfigState } = useRosettaConfig();
  useEffect(() => {
    if (!rosettaConfigState.result) return;

    const eventBus = new AbandonedCartFlowEventBus();
    const storage = new AbandonedCartFlowCookieStateStorage(config.rosetta.cookieDomain);
    const controller = new AbandonedCartFlowController({
      settings: rosettaConfigState.result.abandonedCartFlowSettings,
      storage,
    });
    const { cleanup } = controller.setup(eventBus);

    setInstances({
      abandonedCartFlow: {
        controller,
        eventBus,
      },
    });

    return cleanup;
  }, [rosettaConfigState]);

  return <RosettaContext.Provider value={instances}>{children}</RosettaContext.Provider>;
};
RosettaContextProvider.displayName = "RosettaContextProvider";

export function useRosettaContext() {
  return useContext(RosettaContext);
}
